import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ValueProposition from "./components/ValueProposition";
import Services from "./components/Services";
import Trust from "./components/Trust";
import About from "./components/About";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CookieBanner from './components/CookieBanner';

export default function Home() {
  return (
    <main className="font-inter">
      <Navbar />
      <Hero />
      <ValueProposition />
      <Services />
      <Trust />
      <About />
      <FAQ />
      <Contact />
      <Footer />
      <CookieBanner />
    </main>
  );
}
